import { Typography } from '@mui/material';
import { lightBlue } from '@mui/material/colors';
import { getTickFormat } from 'pages/Dashboard/utils/trackingUtils';
import React from 'react';
import { Payload } from 'recharts/types/component/DefaultTooltipContent';

function isNumericValue(val: unknown): boolean {
  return (
    (typeof val === 'number' && !isNaN(val))
    || (typeof val === 'string' && val !== '' && !isNaN(Number(val)))
  );
}

function getFormattedBarTooltip(bar:
  { key: string;
    label: string;
    color: string;
    units: string;
    value: number | string }) {
  const isNumeric = isNumericValue(bar.value);
  const formattedValue = isNumeric
    ? new Intl.NumberFormat('en-IN').format(Number(bar.value))
    : bar.value;
  return formattedValue;
}

type AppleHealthChartTooltipProps = {
  isInDays: boolean;
  data: { key: string, label: string, color: string, units: string, value: number }[];
  label?: number;
  payload?: Payload<string | number | (string | number)[], string | number>[] | undefined;
  active?: boolean;
};

function AppleHealthChartTooltip({
  active,
  data,
  payload,
  label,
  isInDays,
}: AppleHealthChartTooltipProps) {
  if (active && payload && payload.length) {
    const { day, date, year } = getTickFormat(label as number, isInDays, 'MMM d');
    const finalLabel = isInDays ? `${day}, ${date}` : `${date}, ${year}`;

    return (
      <div
        style={{
          background: lightBlue[50],
          padding: '10px',
          borderRadius: '5px',
          boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Typography variant='caption' component='p' color='text.primary'>{finalLabel}</Typography>
        {data.map((bar) => {
          if (bar.value > 0) {
            return (
              <Typography variant='caption' color={bar.color} key={bar.key} marginTop={2}>
                <Typography variant='caption'>{bar.label}</Typography>
                <Typography variant='caption' display='flex'>
                  <Typography variant='caption'>
                    {getFormattedBarTooltip(bar)}
                  </Typography>
                  <Typography variant='caption' component='span' color='text.primary' ml={0.5}>
                    {bar.units?.toLowerCase()}
                  </Typography>
                </Typography>
              </Typography>
            );
          }
          return null;
        })}
      </div>
    );
  }

  return null;
}

export default AppleHealthChartTooltip;
